import axios from 'axios';

// Backend origin. Empty — the default — means same-origin
const host = process.env.REACT_APP_API_HOST || '';
const port = process.env.REACT_APP_API_PORT || '';
const API_URL = host && port ? `${host}:${port}` : host;

console.log('API base URL =', API_URL || '(same origin)');

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Overall client request timeout, kept above nginx's proxy_read_timeout
  // (120s for /api/) so a slow agent turn surfaces as nginx's 504 — or finishes
  // downloading — instead of the client aborting first.
  timeout: 150000,
});

export default axiosInstance;
